import { NgTemplateOutlet } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

import { BaseRendererComponent, FormatService, RepeatClickButtonComponent } from 'tms-lib';
import { UnitOfMeasures } from 'tms-web-shared';

@Component({
  selector: 'app-product-quantity-renderer',
  templateUrl: './product-quantity-renderer.component.html',
  styleUrl: './product-quantity-renderer.component.scss',
  imports: [NgTemplateOutlet, RepeatClickButtonComponent],
})
export class ProductQuantityRendererComponent extends BaseRendererComponent implements ICellRendererAngularComp {
  protected readonly formatService = inject(FormatService);

  get productType() {
    return this.rowData[this.params.productTypeField];
  }

  get price() {
    return this.rowData[this.params.priceField] === 0
      ? ''
      : this.formatService.currency(this.rowData[this.params.priceField], this.rowData[this.params.currencyField]);
  }

  get total() {
    return this.rowData[this.params.priceField] === 0
      ? ''
      : this.formatService.currency(
          this.rowData[this.params.priceField] * this.params.value,
          this.rowData[this.params.currencyField],
        );
  }

  get unitOfMeasure() {
    return this.rowData[this.params.unitOfMeasureField];
  }

  get sampleOutOfStockMessage() {
    return this.formatService.multiLineToHtml(this.rowData[this.params.sampleOutOfStockMessage]);
  }

  get isEach() {
    return this.unitOfMeasure === UnitOfMeasures.each;
  }

  get canMinus() {
    return this.isEach && this.canDelete;
  }

  get canDelete() {
    return this.params.value > 0;
  }

  get showNumber() {
    return this.rowData[this.params.showNumber];
  }

  updateQuantity(event: any) {
    this.params.update({ ...this.rowData, [this.colId]: event.target.value });
  }
}
